export default {
  title: 'Histórico de lotes de QR Codes',
  name: 'Nome',
  qrcodes: 'QR Codes',
  date: 'Data',
  pdf: 'PDF'
}
